'use client';

import { useActionState } from 'react';

import signUpNewsletter from '@/actions/signUpNewsletter';

function NewsletterSignup() {
  const [state, action, isPending] = useActionState(signUpNewsletter, {
    status: 'idle',
    message: '',
  } as any);

  return (
    <>
      <form className="space-y-6" action={action}>
        <input
          type="email"
          name="email"
          aria-label="E-post"
          placeholder="E-post"
          required
          className="focus:ring-white rounded-sm w-full border border-gray-300 px-6 py-2 focus:outline-none focus:ring text-black"
        />
        <button
          type="submit"
          className="bg-white uppercase duration-50 px-6 py-2 font-bold font-futura text-black transition-all ease-in-out hover:scale-[1.03]"
          disabled={isPending}
        >
          {isPending ? 'REGISTRERER...' : 'REGISTRER'}
        </button>
      </form>
      {state.status === 'success' && <p className="mt-4 text-green-800">{state.message}</p>}
      {state.status === 'error' && <p className="mt-4 text-red-700">{state.message}</p>}
    </>
  );
}

export default NewsletterSignup;
